import { render, staticRenderFns } from "./TabelaDeNotasFiscaisEmitidas.vue?vue&type=template&id=05fd151e&scoped=true"
import script from "./TabelaDeNotasFiscaisEmitidas.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeNotasFiscaisEmitidas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeNotasFiscaisEmitidas.vue?vue&type=style&index=0&id=05fd151e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd151e",
  null
  
)

export default component.exports